export const GET_ROOM_GROUPS_REQUEST = "GET_ROOM_GROUPS_REQUEST";
export const GET_ROOM_GROUPS_SUCCESS = "GET_ROOM_GROUPS_SUCCESS";
export const GET_ROOM_GROUPS_REJECT = "GET_ROOM_GROUPS_REJECT";
export const ADD_ROOM_GROUP_REQUEST = "ADD_ROOM_GROUP_REQUEST";
export const ADD_ROOM_GROUP_SUCCESS = "ADD_ROOM_GROUP_SUCCESS";
export const ADD_ROOM_GROUP_REJECT = "ADD_ROOM_GROUP_REJECT";
export const EDIT_ROOM_GROUP_REQUEST = "EDIT_ROOM_GROUP_REQUEST";
export const EDIT_ROOM_GROUP_SUCCESS = "EDIT_ROOM_GROUP_SUCCESS";
export const EDIT_ROOM_GROUP_REJECT = "EDIT_ROOM_GROUP_REJECT";
export const REMOVE_ROOM_GROUP_REQUEST = "REMOVE_ROOM_GROUP_REQUEST";
export const REMOVE_ROOM_GROUP_SUCCESS = "REMOVE_ROOM_GROUP_SUCCESS";
export const REMOVE_ROOM_GROUP_REJECT = "REMOVE_ROOM_GROUP_REJECT";



// WEBPACK FOOTER //
// ./src/rooms/groups/constants.js